module.exports = __webpack_public_path__ + "static/media/NEAR-BNB.7578256d.svg";